import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";

export const useUsunRaport = (prefix = 'oper') => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => deleteItem(`/${prefix}/raporty/${id}`),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: [`${prefix}_raporty`]
            })
        },
        onSuccess: ({message}) => {
            if (message) return  toast.success(message)
        },
        onError: ({message}) => {
            if (message) return  toast.error(message)
        }
    });
};
